import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddMarginCapital = ({ show, onClose, onCreated }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [selectedOption, setSelectedOption] = useState(null);
    const [marginCapital, setMarginCapital] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [marginLengthError, setMarginLengthError] = useState('');
    const [descLengthError, setDescLengthError] = useState('');

    const order_type = [
        { value: "0", label: "Subscription Order" },
        { value: "1", label: "Catering Order" },
        { value: "2", label: "Corporate Order" },
    ];

    const handleSubmit = async () => {
        setErrors({});
        setMarginLengthError('');
        setDescLengthError('');

        const capitalizeFirstLetter = (text) => {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1);
        };

        const formattedDescription = capitalizeFirstLetter(description);

        if (!selectedOption) {
        setErrors({ order_type: 'Order Type is required' });
        return;
        }

        const marginCapitalNumber = Number(marginCapital);
        if (!marginCapital || isNaN(marginCapitalNumber) || marginCapitalNumber < 1 || marginCapitalNumber > 100) {
        setErrors(prev => ({ ...prev, marginCapital: 'Margin Capital must be a number between 1 and 100' }));
        return;
        }

        if (marginCapital.length > 50) {
        setMarginLengthError('Limit reached (max 50 characters)');
        return;
        }

        if (formattedDescription.length > 500) {
        setDescLengthError('Limit reached (max 500 characters)');
        return;
        }

      
        const user_id = parseInt(localStorage.getItem("user_id"), 10);

        const payload = {
            order_type: selectedOption.value,
            margin_capital: marginCapital,
            description: description,
            user_id: user_id,
        };

        try {
            await axios.post(`${baseURL}/margincapital/add_margin`, payload);
            toast.success("Margin Capital created successfully!");
            onClose();
            if (onCreated) onCreated();
        } catch (error) {
            if (error.response && error.response.status === 400 && error.response.data.errors) {
            console.error('Validation errors:', error.response.data.errors);
            setErrors(error.response.data.errors);
            toast.error("Validation failed: " + Object.values(error.response.data.errors).flat().join(' '));
            } else {
            toast.error("Creation failed.");
            console.error("Create error:", error);
            }
        }
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Margin Capital</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Order Type<span className="required">*</span></label>
                            <Select
                                placeholder='Select Order Type'
                                value={selectedOption}
                                onChange={setSelectedOption}
                                options={order_type}
                                className={errors.order_type ? 'is-invalid' : ''}
                            />
                            {errors.order_type && <div className="text-danger">{errors.order_type}</div>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Margin Capital<span className="required">*</span></label>
                            <input
                                type="text"
                                className={`form-control ${errors.marginCapital ? 'is-invalid' : ''}`}
                                placeholder="Enter Margin Capital"
                                value={marginCapital}
                                onChange={e => {
                                    setMarginCapital(e.target.value);
                                    if(e.target.value.length <= 50) setMarginLengthError('');
                                }}
                            />
                            {errors.marginCapital && <div className="invalid-feedback d-block">{errors.marginCapital}</div>}
                            {marginLengthError && <span className="text-danger">{marginLengthError}</span>}
                        </div>
                       <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description<span className=""></span></label>
                           <textarea
                            className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                            placeholder="Enter Description"
                            value={description}
                            onChange={e => {
                                let val = e.target.value;
                                if (val.length > 0) {
                                val = val.charAt(0).toUpperCase() + val.slice(1);
                                }
                                setDescription(val);

                                if (val.length <= 500) setDescLengthError('');
                            }}
                            rows={4}
                            />

                            {errors.description && <div className="text-danger">{errors.description}</div>}
                            {descLengthError && <span className="text-danger">{descLengthError}</span>}
                        </div>

                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>
                            Create Margin Capital
                            <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddMarginCapital;
